﻿import { Injectable } from '@angular/core';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import { config } from '../../assets/config';
import {Intercalaire} from '../_models/intercalaire';

@Injectable()
export class IntercalaireService {
    constructor(private http: HttpClient) {}

    getAll() {
        return this.http.get<Intercalaire[]>(`${config.apiUrl}/intercalaires`);
    }

    getById(id: number) {
        return this.http.get(`${config.apiUrl}/intercalaires/` + id);
    }

    getByPatientId(id: string) {
        return this.http.get(`${config.apiUrl}/patients/` + id + '/intercalaires?filter={"include":["words"]}');
    }

    register(intercalaire: Intercalaire) {
        return this.http.post(`${config.apiUrl}/intercalaires`, intercalaire);
    }

    registerByPatientId(id: string, intercalaire: Intercalaire) {
        return this.http.post(`${config.apiUrl}/patients/` + id + '/intercalaires/', intercalaire, {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
            })
        });
    }

    update(intercalaire: Intercalaire) {
        return this.http.put(`${config.apiUrl}/intercalaires/` + intercalaire.id, intercalaire);
    }

    delete(id: number) {
        return this.http.delete(`${config.apiUrl}/intercalaires/` + id);
    }
}
